import type { Dispatch, FC, MouseEvent, SetStateAction } from 'react';
import React, { useState } from 'react';
import type { TOnChangeValue } from '@alfa-bank/site-checkbox/src/components/checkbox/models';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TAgreementCheckbox } from './models';

export const AgreementCheckbox: FC<TAgreementCheckbox> = props => {
    const {
        Checkbox,
        Link,
        Modal,
        agreementModalContent: AgreementModalContent,
        analytics,
        appendix,
        checked,
        className,
        conditionsModalContent: ConditionsModalContent,
        dataTestId = 'agreement-checkbox',
        disabled = false,
        error = false,
        forwardedRef,
        modalSize,
        name = '',
        namedContainers,
        onChange,
        sendEvent,
        value,
        withoutBKI = false,
        withoutConditions = false,
    } = props;

    const [isConditionsModalOpen, changeConditionsModalOpen] = useState(false);
    const [isAgreementModalOpen, changeAgreementModalOpen] = useState(false);

    const handleLinkClick =
        (openModalHandler: Dispatch<SetStateAction<boolean>>) =>
        (data: { event: MouseEvent<HTMLSpanElement | HTMLAnchorElement> }) => {
            if (disabled) return;

            if (data && data.event) {
                data.event.preventDefault();
            }
            openModalHandler(true);

            if (openModalHandler === changeConditionsModalOpen && analytics?.conditions) {
                sendEvent(analytics.conditions);
            }

            if (openModalHandler === changeAgreementModalOpen && analytics?.agreement) {
                sendEvent(analytics.agreement);
            }
        };
    const handleCheckboxClick = (event: TOnChangeValue) => {
        if (analytics?.agreementCheckbox) {
            sendEvent(analytics.agreementCheckbox);
        }
        onChange(event);
    };
    const handleModalClose = (openModalHandler: Dispatch<SetStateAction<boolean>>) => () => {
        openModalHandler(false);
    };

    const text = namedContainers?.agreementCheckboxText ? (
        namedContainers?.agreementCheckboxText
    ) : (
        <Text styler={{ margin: 0 }} view="primary-medium">
            Я&nbsp;
            {!withoutConditions && (
                <>
                    соглашаюсь с&nbsp;
                    <Link
                        dataTestId={dataTestId + '-link-conditions'}
                        kind="common"
                        onClick={handleLinkClick(changeConditionsModalOpen)}
                        pseudo
                    >
                        условиями
                    </Link>
                    &nbsp;и&nbsp;
                </>
            )}
            даю своё&nbsp;
            <Link
                dataTestId={dataTestId + '-link-personal-data'}
                kind="common"
                onClick={handleLinkClick(changeAgreementModalOpen)}
                pseudo
            >
                согласие&nbsp;на&nbsp;обработку
            </Link>{' '}
            и&nbsp;использование моих персональных данных
            {!withoutBKI && ', и\u00A0разрешаю сделать запрос в\u00A0бюро кредитных историй'}
            {appendix}
        </Text>
    );

    return (
        <>
            <Checkbox
                checked={checked}
                className={className}
                dataTestId={dataTestId}
                disabled={disabled}
                error={error}
                forwardedRef={forwardedRef}
                name={name}
                onChange={handleCheckboxClick}
                size="m"
                theme="white"
                type="checkmark"
                value={value}
            >
                {text}
            </Checkbox>

            {isConditionsModalOpen && (
                <Modal onClose={handleModalClose(changeConditionsModalOpen)} size={modalSize}>
                    {namedContainers?.conditionsModalContent || <ConditionsModalContent />}
                </Modal>
            )}
            {isAgreementModalOpen && (
                <Modal onClose={handleModalClose(changeAgreementModalOpen)} size={modalSize}>
                    {namedContainers?.agreementModalContent || <AgreementModalContent />}
                    {namedContainers?.editionContent}
                </Modal>
            )}
        </>
    );
};
